import { Button } from "@mui/material";
import type { ReactNode } from "react";

export type Props = {
  label: ReactNode;
  onClick?: () => void;
};

export const Cell = ({ label, onClick }: Props) => {
  if (onClick) {
    return (
      <Button
        variant="outlined"
        disableRipple={false}
        onPointerDown={onClick}
        sx={{
          width: "100%",
          height: "100%",
          minWidth: 0,
          minHeight: 0,
          borderRadius: 0,
          fontSize: "1.4rem",
          border: "none",
          color: ({ palette }) => palette.text.primary,
        }}
      >
        {label}
      </Button>
    );
  }

  return <>{label}</>;
};
